<template>
  <div class="page-landing-awards">
    <div class="container is-gap-top" data-aos="fade-in" data-aos-once="true">
      <div class="columns is-gapless is-multiline is-flex is-centered">
        <div class="column is-10-mobile is-11-tablet is-9-desktop">
          <div class="is-gap is-pad-large" style="margin-left:auto;margin-right:auto;">
            <div class="columns is-multiline is-flex is-centered">
              <div v-for="(sp, index) in (data || [])" :key="`${index}`"
                class="column is-6-mobile is-3-tablet is-3-desktop is-pad">
                <img v-if="sp && sp.image && sp.image.path"
                  :src="sp && sp.image && sp.image.path"
                  style="width:100%;"
                  role="img"
                  :alt="sp.image && sp.image.description"
                  :title="sp.image && sp.image.description"
                  :aria-label="sp.image && sp.image.description" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from '@/util'
import EventBus from '@/controllers/EventBus'

export default {
  name: 'page-landing-awards',
  props: {
    // msg: String
    data: Array
  },
  components: {
  },
  data () {
    return {
      isDesktop: true,
      loading: false,
    }
  },
  computed: {
    Util: function () {
      return Util
    }
  },
  watch: {
  },
  created () {
  },
  async mounted () {
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))
  },
  methods: {
  },
}
</script>

<style lang="scss" src="../../styles/base.scss"></style>
<style scoped lang="scss">
@import "../../styles/app_setting.scss";

// .page-landing-awards {
// }

</style>
